export default __webpack_public_path__ + "assets/8184037c19e39ba6d7123a948ba1f2f6.png";